<template>
    <div v-if="identity" class="contactBox">
        <h3>{{getName()}}</h3>
        <img :src="imagepath" alt="" height="160" width="160" @error="nophoto" />
        <a :href="'mailto:'+identity.emailAddress" class="flink">✉ email</a>
        <p v-html="getPhone()"></p>
    </div>
</template>

<script>

export default {
  name: 'staffContact',
  props: {
    upi: String
  },
  data: function () {
      return {
            identity: {displayName:"...", names:[], phones:[]},
            imagepath: "/_images/nophoto.svg"
      }
  },
  methods: {
      nophoto: function(){
          this.imagepath = "/_images/nophoto.svg";
      },
      getName: function(){
        let prefname = this.identity.names.find(u=>u.type=="Preferred");
        if (prefname)
            return `${prefname.title} ${prefname.first} ${prefname.last}`;
        return this.identity.displayName;
      },
      getPhone: function(){
          let phone = "";
          let campusphone = this.identity.phones.find(u=>u.typeId == "Campus");
          if (campusphone){
              phone = `☎ <a class="flink" href="tel:0${campusphone.areaCode}${campusphone.number}">+${campusphone.countryCode} (0) ${campusphone.areaCode} ${campusphone.number}</a><br/>Ext:${campusphone.extension}`;
          }
          return (phone);
      }
  },
  created: async function(){
        const resp = await fetch(process.env.VUE_APP_ENDP2+"?rubber=monkey&id="+this.upi,
        { method: 'GET', mode: 'cors', credentials: 'include' });
        const json = await (resp.json());
        if (json.idPhotoExists)
        {
            let pname = this.upi;
            if (json.emailAddress.split("@")[0].indexOf("-")<0) // if not hyphenated name, use email with .==>-, else upi
                pname = json.emailAddress.split("@")[0].replaceAll(".","-");
                this.imagepath = `https://profiles.auckland.ac.nz/${pname}/thumbnail`;
        }
        this.identity = json;
  }
}
</script>

<style>
.contactBox {
    display: inline-flex;
    flex-direction: column;
    border: 1px solid;
    background-color: white;
    padding: 1em;
    box-shadow: 0 2px 3px currentColor;
    margin: 1em;
}
.contactBox>p::first-letter{
    font-size: 1.1em;
}
.contactBox>img {
    align-self: center;
}
.contactBox>p{
    color: black;
}
</style>
